export default function Toggle({ value, onChange }) {
  return (
    <div className={`lfx-toggle ${value ? "on" : ""}`} onClick={() => onChange(!value)}>
      <div className="lfx-toggle-thumb" />
    </div>
  );
}
